import { FONT_BRIGHTNESS_MAPPING } from "../../theme/src";
import { LINE_WIDTH, TIMELINE_STATUS } from './constants';
export const getStatusColor = (status) => {
    const mapStatusColorName = {
        [TIMELINE_STATUS.CURRENT]: 'primary',
        [TIMELINE_STATUS.PENDING]: 'banana',
        [TIMELINE_STATUS.DONE]: 'primary',
        [TIMELINE_STATUS.ERROR]: 'fire',
        [TIMELINE_STATUS.DEFAULT]: 'asphalt',
    };
    return (mapStatusColorName[status] || mapStatusColorName[TIMELINE_STATUS.DEFAULT]);
};
export const getPinStyles = ({ $status, theme }) => {
    const statusColor = getStatusColor($status);
    switch ($status) {
        case TIMELINE_STATUS.PENDING:
        case TIMELINE_STATUS.DONE:
        case TIMELINE_STATUS.ERROR:
        case TIMELINE_STATUS.CURRENT:
            return `
        background-color: ${theme.colors[statusColor]};
      `;
        default:
            return `
        background-color: transparent;
        border: ${LINE_WIDTH}px solid ${FONT_BRIGHTNESS_MAPPING.black[theme.themeVariables.fontBrightness]};
      `;
    }
};
export const getPinPositionTop = ({ theme }) => `calc(${theme.lineHeights[4]} / 2)`;
//# sourceMappingURL=utils.js.map